import { event } from './event';

export const seo = {
  lang: 'fr',
  locale: 'fr_MA',
  title: 'Premier webinaire – La Rentrée Touristique by CNT',
  description:
    'Accédez au premier webinaire de La Rentrée Touristique, organisé par la Confédération Nationale du Tourisme (CNT) : remplissez le formulaire dès maintenant et rejoignez le live lundi à 15h00.',
  siteName: 'La Rentrée Touristique by CNT',
  image: event.eventLogo,
  imageAlt: 'Logo La Rentrée Touristique by CNT',
  themeColor: '#EFEFEF',
  keywords:
    'Rentrée Touristique, CNT, Confédération Nationale du Tourisme, webinaire, tourisme Maroc, live',
  eventStart: '2026-09-28T15:00:00+01:00',
  organizerName: 'Confédération Nationale du Tourisme',
};
